import styled from 'styled-components'

import { mediaQueries, palette } from '../../styles/variables'

export const LeftSection = styled.div({
  minWidth: '390px',
  padding: '32px 32px 20px 32px',
  position: 'relative',
  height: 'fit-content',
  minHeight: '740px',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  boxSizing: 'border-box',
  backgroundColor: palette.white,

  '@media (pointer:none), (pointer:coarse)': {
    padding: '32px 32px 44px 32px',
  },

  [mediaQueries.mobile]: {
    minHeight: 'fit-content',
    textAlign: 'center',
    minWidth: '100%',
    padding: '64px 32px 64px 32px',
  },
})

export const RightSection = styled.div({
  flexGrow: 1,
  padding: '96px 32px 32px 32px',
  display: 'flex',
  height: 'fit-content',
  minHeight: '740px',
  [mediaQueries.mobile]: {
    minHeight: 'unset',
    padding: '48px 32px',
    flexGrow: 1,
  },
})

export const RightWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
})
